import React from "react";
import { FormattedMessage } from "react-intl";
import { Button, PopoverBody, UncontrolledPopover } from "reactstrap";

import { MAX_FILTER_DAYS } from "../../constants";
import { WaIcon } from "@ui/WaIcon";

export const SalesInfoPopover = () => {
    return (
        <div className="sales-info-popover">
            <Button
                color="link"
                id="sales-info-popover"
                className="sales-info-popover__button"
                onClick={(e) => (e.currentTarget as HTMLButtonElement).focus()}
            >
                <WaIcon name="info" />
            </Button>
            <UncontrolledPopover
                placement="left"
                target="sales-info-popover"
                trigger="focus"
            >
                <PopoverBody className="sales-info-popover__body">
                    <FormattedMessage
                        id="sales.info-popover.body"
                        defaultMessage={
                            "<p>The maximum range you can search on is {days} days. "
                            + "If you need data for a larger range, please contact {provider}.</p>"
                            + "<p>YouTube trends may not be reflective of the final views shown in statements. "
                            + "These trends figures should be treated as a guide only.</p>"
                        }
                        values={{
                            days: MAX_FILTER_DAYS,
                            provider: "Modulor",
                        }}
                    />
                </PopoverBody>
            </UncontrolledPopover>
        </div>
    );
};
